module.exports = __webpack_public_path__ + "static/media/logo.8071fbe6.png";